export function summaryCalculation(originalBalance, originaleIncome, originalExpense, simulatedTransactions) {
    let changeInBalance = 0;
    let changeInIncome = 0;
    let changeInExpense = 0;

    for (let transaction of simulatedTransactions) {
        if (transaction.isCredit) {
            //if the transaction is credit, it means that the user changed an income transaction
            //so we need to reduce the income and the balance
            changeInBalance -= transaction.delta;
            changeInIncome -= transaction.delta;
        } else {
            //if the transaction is not credit, it means that the user changed an expense transaction
            //so we need to increase the expense and the balance
            changeInBalance += transaction.delta;
            changeInExpense -= transaction.delta;
        }
    }

    const newBalance = round2Dec(originalBalance + changeInBalance);
    const newIncome = round2Dec(originaleIncome + changeInIncome);
    const newExpense = round2Dec(originalExpense + changeInExpense);
    return { newBalance, newIncome, newExpense };
}

const round2Dec = (number) => {
    return Math.round(number * 100) / 100;
};

export function getMonthIdAndYearFromTime(time) {
    const monthId = Number(time.split("-")[1]).toString();
    const year = `20${time.split("-")[2]}`;
    return { monthId, year };
}
